"use client";

import React, { useMemo } from "react";
import { Box } from "@mui/material";
import BrandProductsList from "@/main/brands/[id]/_components/brand-products-list";
import CustomBreadcrumbs from "@/main/category/(components)/custom-breadcrumbs";
import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";

interface ProductItem {
  name: string;
  id: string;
  subtitle: string;
  type: string;
  original_image: string;
  seo_url: number;
  price: number;
  special: number;
}

interface Manufacturer {
  manufacturer_id: number;
  name: string;
  image: string;
  original_image: string;
}

interface BrandItemProps {
  items: ProductItem[];
  manufacturer: Manufacturer;
}

const BrandItem = ({ data, id }: { data: BrandItemProps; id: string }) => {
  const { i18n } = useLingui();
  const products = useMemo(() => data.items || [], [data.items]);
  const manufacturerName = useMemo(
    () => (data?.manufacturer?.name ? data.manufacturer.name : t(i18n)`Brand`),
    [data?.manufacturer?.name, i18n],
  );

  return (
    <main className="md:container">
      <div className="flex flex-col xs:pt-[75px] md:pt-0">
        <div className="w-full">
          <ul className="pb-2.5 xs:px-[15px] md:px-0 md:pb-[25px]">
            <CustomBreadcrumbs
              crumbs={[
                { title: t(i18n)`Brands`, link: "/brands" },
                { title: manufacturerName, link: `/brands/${id}` },
              ]}
            />
          </ul>
        </div>
        <Box sx={{ mx: { xs: "15px", md: 0 } }}>
          <BrandProductsList products={products} manufacturerName={manufacturerName} />
        </Box>
      </div>
    </main>
  );
};
export default BrandItem;
